import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { createSmartConnectSetting } from "../../../store/slices/smartConnect/smartConnectSettings";

function CreateSmartConnectSettingComponent({ show, onClose, onSuccess }) {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    setting_name: "",
    dids_per_agent: "",
    days_to_spam: "",
    days_to_shuffle: "",
    days_to_assign_additional_did: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCreate = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.data?.id) {
        toast.error("User not found. Please re-login.");
        return;
      }

      const payload = {
        setting_name: form.setting_name.trim(),
        dids_per_agent: Number(form.dids_per_agent),
        days_to_spam: Number(form.days_to_spam),
        days_to_shuffle: Number(form.days_to_shuffle),
        days_to_assign_additional_did: Number(
          form.days_to_assign_additional_did,
        ),
        created_by: user.data.id,
        updated_by: user.data.id,
      };

      const result = await dispatch(
        createSmartConnectSetting(payload),
      ).unwrap();

      toast.success("Setting created successfully");

      console.log("Result after setting created : ", result);
      //   {
      //     "setting_name": "Dynamic Agent Group 3",
      //     "dids_per_agent": 20,
      //     "days_to_spam": 90,
      //     "days_to_shuffle": 2,
      //     "days_to_assign_additional_did": 60,
      //     "created_by": 16,
      //     "updated_by": 16,
      //     "id": 6,
      //     "created_at": "2026-01-24T06:27:18.767Z",
      //     "updated_at": "2026-01-24T06:27:18.767Z"
      // }

      onSuccess?.(result?.data || result);

      onClose();

      setForm({
        setting_name: "",
        dids_per_agent: "",
        days_to_spam: "",
        days_to_shuffle: "",
        days_to_assign_additional_did: "",
      });
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-semibold">
          Create Smart Connect Setting
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-2">
        <Form>
          {/* Setting Name */}
          <Form.Group className="mb-4">
            <Form.Label className="fw-medium">Setting Name</Form.Label>
            <Form.Control
              name="setting_name"
              value={form.setting_name}
              onChange={handleChange}
              placeholder="e.g. Sales Team – High Volume"
            />
            <Form.Text className="text-muted">
              Use a meaningful name to identify this configuration later.
            </Form.Text>
          </Form.Group>

          {/* Rules Section */}
          <div className="p-3 rounded bg-light border">
            <h6 className="mb-3 text-secondary fw-semibold">
              DID Assignment Rules
            </h6>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>DIDs per Agent</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    name="dids_per_agent"
                    value={form.dids_per_agent}
                    onChange={handleChange}
                    placeholder="e.g. 2"
                  />
                  <Form.Text className="text-muted">
                    Number of DIDs assigned to each agent.
                  </Form.Text>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Days to Spam Active DIDs</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    name="days_to_spam"
                    value={form.days_to_spam}
                    onChange={handleChange}
                    placeholder="0"
                  />
                  <Form.Text className="text-muted">
                    Set <strong>0</strong> to disable spamming.
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Days to Shuffle Active DIDs</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    name="days_to_shuffle"
                    value={form.days_to_shuffle}
                    onChange={handleChange}
                    placeholder="0"
                  />
                  <Form.Text className="text-muted">
                    Set <strong>0</strong> to keep DIDs fixed.
                  </Form.Text>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Days to Assign Additional DIDs</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    name="days_to_assign_additional_did"
                    value={form.days_to_assign_additional_did}
                    onChange={handleChange}
                    placeholder="0"
                  />
                  <Form.Text className="text-muted">
                    Set <strong>0</strong> if no extra DIDs should be assigned.
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="primary"
          disabled={!form.setting_name.trim() || loading}
          onClick={handleCreate}
          className="px-4"
        >
          {loading ? <Spinner size="sm" /> : "Create Setting"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateSmartConnectSettingComponent;
